import CloseIcon from '@mui/icons-material/Close';
import { Box, Drawer, Grid, IconButton, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import * as React from 'react';
import { useSettingValueByCode } from '../../contexts/SettingsContext';
import { getLocationFromProperties } from '../../services/page-service';
import { EXTRA_WIDGETS, WIDGET_LIST } from '../../utils/constants';
import { checkRoles, checkSettings } from '../../utils/util';
import '../WidgetsSidebar/WidgetsSidebar.css';

const useStyles: any = makeStyles((theme: Theme) => ({
	thresholdContainer: {
		// padding: '1rem',
		display: 'flex',
		flexDirection: 'column'
	},
	headerText: {
		fontWeight: 600,
		fontSize: '18px',
		lineHeight: '21px',
		color: '#212121'
	},
	subTitle: {
		fontWeight: 400,
		fontSize: '12px',
		lineHeight: '4px',
		color: '#536580',
		'margin-bottom': ' 10px'
	},
	drawerGutter: {
		paddingLeft: '24px',
		paddingRight: '24px',
		paddingTop: '84px',
		backgroundColor: '#ffffff',
	},
	drawerBorder: {
		borderBottom: '1px solid #E0E0E0',
		marginTop: '5px',
		marginBottom: '10px',
		width: '100%',
		marginLeft: '0px',
		boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
	}
}));

type Props = {
	toggleDrawer: any;
	isOpen: boolean | undefined;
};

const WidgetsSidebar = ({ isOpen, toggleDrawer }: Props) => {
	const classes = useStyles();
	const [allowedWidgets, setAllowedWidgets] = React.useState<any[]>(WIDGET_LIST);
	const [filteredWidgetList, setFilteredWidgetList] = React.useState<any[]>(WIDGET_LIST);
	let refreshInterval = useSettingValueByCode("ACTV_ALT_INTERVAL") || 0;

	const handleSearch = (event: any) => {
		if (!event.target.value) {
			setFilteredWidgetList(allowedWidgets);
		}
		const filteredList = (allowedWidgets).filter((widget) => widget.label.toLowerCase().includes(event.target.value.toLowerCase()));
		setFilteredWidgetList(filteredList);
	};
	const handleDragStart = (event: React.DragEvent<HTMLDivElement>, item: any) => {
		event.dataTransfer?.setData('widgetData', JSON.stringify(item));
	};

	function resetWidgets() {
		setAllowedWidgets(WIDGET_LIST)
		setFilteredWidgetList(WIDGET_LIST)
	}
	const componentRef = React.useRef<HTMLDivElement>(null);

	React.useEffect(() => {
		if (!isOpen) {
			return;
		}
		function handleClickOutside(event: MouseEvent): void {
			if (componentRef.current && !componentRef.current.contains(event.target as Node)) {
				toggleDrawer(false);
			}
		}
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isOpen, toggleDrawer]);


	React.useEffect(() => {
		try {
			checkSettings("MULTI_LEVEL_FILTER").then(async (resp: any) => {
				console.log("MULTI_LEVEL_FILTER", resp)
				let NewWidgets = [...WIDGET_LIST]

				try {
					if (getLocationFromProperties() !== "us") {
						NewWidgets = NewWidgets.filter(item => item?.label !== "Activity Log")
					} else {
						let interval: number = Number(refreshInterval);
						interval = isNaN(interval) ? 0 : interval;
						if (interval < 1) {
							NewWidgets = NewWidgets.filter(item => item?.label !== "Activity Log")
						}

					}
				} catch (error) {
					console.error(error)
				}

				try {
					if (resp && (resp === true || resp === "true")) {
						EXTRA_WIDGETS.forEach((item) => {
							if (item.settingsCode === "MULTI_LEVEL_FILTER" && checkRoles("ROLE_DATA_ACCESS")) {
								NewWidgets.push(item)
							}
						})
					}
				} catch (err) {
					console.log(err)
				}

				try {
					const respCustomTags = await checkSettings("CALL_CENTER_WIDGET")
					if (respCustomTags && (respCustomTags === true || respCustomTags === "true")) {
						EXTRA_WIDGETS.forEach((item) => {
							if (item.settingsCode === "CALL_CENTER_WIDGET") {
								NewWidgets.push(item)
							}
						})
					}
				} catch (err) {
					console.log(err)
				}

				try {
					const respAgentMonitor = await checkSettings("AGENT_MONITOR_WFM");
					if (respAgentMonitor && (respAgentMonitor === true || respAgentMonitor === "true")) {
						EXTRA_WIDGETS.forEach((item) => {
							if (item.settingsCode === "AGENT_MONITOR_WFM") {
								NewWidgets.push(item)
							}
						})
					}
				} catch (err) {
					console.log(err)
				}

				setAllowedWidgets(NewWidgets)
				setFilteredWidgetList(NewWidgets)
			}).catch((err) => {
				resetWidgets()
				console.log(err)
			})
		} catch (err) {
			resetWidgets()
			console.log(err)
		}
	}, [refreshInterval]);

	return (
		<Drawer
			variant="persistent"
			ModalProps={{
				hideBackdrop: true
			}}
			open={isOpen}
			anchor={'right'}
			onClose={() => toggleDrawer(false)}
		>
			<Box ref={componentRef} sx={{ width: 465 }} className={classes.thresholdContainer}>
				<div className={classes.drawerGutter}>
					<Grid container direction="row" justifyContent="space-between" alignItems="center">
						<Grid item>
							<span className={classes.headerText}>Add Widget</span>
						</Grid>
						<Grid item xs={8}>
							<Grid container spacing={2} justifyContent="flex-end">
								<Grid item xs={8}>
									<div className="widget-search-container">
										<Grid container spacing={1}>
											<Grid item xs={10}>
												<div className="input-spacing drawer-search-bar">
													<input onChange={handleSearch} type="text" placeholder="Search" />
												</div>
											</Grid>
											<Grid className="input-spacing" item xs={2}>
												<img src={`${process.env.PUBLIC_URL}/img/search-icon.svg`} width="12" alt="Filter Search"></img>
											</Grid>
										</Grid>
									</div>
								</Grid>
								<Grid item xs={2}>
									<IconButton aria-label="delete" size="small" onClick={() => toggleDrawer(false)}>
										<CloseIcon style={{ fontSize: '22px', color: '#99a0a8' }} />
									</IconButton>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<p className={classes.subTitle}>Drag the widget</p>

				</div>
				<div className={classes.drawerBorder}></div>
				<div className="widget-items-container" style={{ height: 'calc(100vh - 150px)', overflowY: 'auto', padding: '1rem' }}>
					<Grid container spacing={2}>
						{filteredWidgetList.length === 0 && (
							<Grid item xs={12} style={{ textAlign: 'center' }}>
								<p className="widget-name">No widgets found</p>
							</Grid>
						)}

						{filteredWidgetList.map((item) => (
							<Grid key={item.widgetName} item xs={item.width || 6}>
								<div className="widget-item-draggable" draggable={true} onDragStart={(event) => handleDragStart(event, item)}>
									<img src={`${process.env.PUBLIC_URL}/thumbnails/${item.image}`} alt={item.label}></img>
									<p className="widget-name">{item.label}</p>
								</div>
							</Grid>
						))}
					</Grid>
				</div>
			</Box>
		</Drawer>
	);
};

export default WidgetsSidebar;